<template>
  <div class="header-box">
    <div class="logo fl">
       <img src="../../assets/title.png" >
    </div>
    <div class="fr mr20 f14 user-info-box">
      <div class="user-list"><img src="../../assets/default.png" alt=""></div>
      <div class="user-list">
        <el-dropdown>
          <span class="el-dropdown-link">
            <b class="userName">用户名</b><i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
    </div>
  </div>
</template>
<script>
// import {mapMutations} from 'vuex'
export default {
    data () {
        return {
        }
    },
    methods: {
        // ...mapMutations({
        //     changePageStatus: 'task/changePageStatus'
        // }),

    }
}
</script>
<style lang="scss">
.fl{
  float: left;
}
.fr{
  float: right;
}
.mr20{
  margin-right: 20px;
}
.f14{
  font-size: 14px;
}
.header-box {
  background: #00A4E0;
  padding: 0 28px;
  height: 70px;
  color:#666666;
  line-height: 70px;
  font-size: 16px;
  cursor: pointer;
}
.user-list {

  float: left;
  .el-dropdown-link{
    color:#fff;
    b{
      margin-left: 15px;
      margin-right: 9px;
    }
  }
  img{
    width: 33px;
    height: 33px;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/header.vue